import EmberObject from '@ember/object';
import Service from '@ember/service';

/**
 * Possible sort types
 *
 * @type {}
 */
export const SORT_QUERY_PARAM__SORT_TYPES = {
  ASCENDING: 'asc',
  DESCENDING: 'desc'
};

/**
 * // TODO --- This service should support instances per route.  Currently it isn't.
 *
 * Service to handle easily encoding/decoding and setting the generic sort param
 */
export default Service.extend({

  /**
   * @type {Object}       The map that will hold all the sorted query params and their sorts as the value.
   */
  _sortMap: EmberObject.create({}),

  /**
   * Add a sort for a given attribute.
   *
   * @param {String} attribute
   * @param {String} sortType     of type SORT_QUERY_PARAM__SORT_TYPES.*
   */
  addSort(attribute, sortType) {
    this.get('_sortMap').set(attribute, sortType);
  },

  /**
   * Clear a sort for a given attribute.
   *
   * @param {String} attribute
   */
  clearSort(attribute) {
    delete this.get(`_sortMap`)[attribute];
  },

  /**
   * Given the passed in query param, set the sort map from the param
   *
   * @param {String} sortQueryParam
   */
  createMapFromQueryParam(sortQueryParam) {
    let sortTuples = sortQueryParam.split(',');
    sortTuples.forEach(sortTuple => {
      let sortArr = sortTuple.split('|');

      if (sortArr.length !== 2) {
        // incorrect sort length
        return;
      }

      this.get('_sortMap').set(sortArr[0], sortArr[1]);
    });
  },

  /**
   * Get the current sort for an attribute.
   *
   * @param {String} attribute
   * @return {String}       of type SORT_QUERY_PARAM__SORT_TYPES.*
   */
  getSort(attribute) {
    return this.get(`_sortMap.${attribute}`);
  },

  /**
   * Get the encoded (not url encoded) query param representing the sort.
   *
   * @return {string}
   */
  getSortQueryParam() {
    let sortTuples = [];
    Object.keys(this.get('_sortMap')).forEach(attribute => {
      sortTuples.push(`${attribute}|${this.get('_sortMap.' + attribute)}`);
    });

    return sortTuples.join(',');
  },

  /**
   * Clear all the sorts in the internal map model.
   */
  clearAllSorts() {
    this.set('_sortMap', EmberObject.create({}));
  }
});
